import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Typography } from '../../index.react';
import { TRANSITION_DURATION, closeStyle, headerStyle, modalWrapperStyle, createContentStyle, createModalStyle, createOverlayStyle } from './createStyle';
var el;

function getRootElement() {
  if (!el) el = document.createElement('div');
  return el;
}

var Modal = function Modal(_a) {
  var children = _a.children,
      onClose = _a.onClose,
      className = _a.className,
      contentCss = _a.contentCss,
      title = _a.title,
      _b = _a.closeButtonAccessibleLabel,
      closeButtonAccessibleLabel = _b === void 0 ? 'Close modal' : _b;

  var _c = useState(false),
      isClosing = _c[0],
      setIsClosing = _c[1];

  var _d = useState(true),
      isOpening = _d[0],
      setIsOpening = _d[1];

  useEffect(function () {
    if (!document.getElementById('modal-root')) {
      var root = document.createElement('div');
      root.setAttribute('id', 'modal-root');
      root.setAttribute('style', 'position:relative;z-index:10');
      var bodyElement = document.querySelector('body');
      bodyElement.appendChild(root);
    }

    var modalRoot = document.getElementById('modal-root');
    var element = getRootElement();
    if (modalRoot) modalRoot.appendChild(element);
    window.setTimeout(function () {
      setIsOpening(false);
    }, TRANSITION_DURATION);
    return function () {
      var element = getRootElement();
      var modalRoot = document.getElementById('modal-root');
      if (modalRoot && modalRoot.contains(element)) modalRoot.removeChild(element);
    };
  }, []);
  useEffect(function () {
    var keyDownHandler = function keyDownHandler(e) {
      if (e.key === 'Escape') close();
    };

    document.addEventListener('keydown', keyDownHandler);
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  function close() {
    setIsClosing(true);
    return new Promise(function (resolve) {
      window.setTimeout(function () {
        onClose();
        resolve();
      }, TRANSITION_DURATION);
    });
  }

  function onOverlayClick(e) {
    e.preventDefault();
    e.stopPropagation();
    close();
  }

  var modal = React.createElement("div", {
    onClick: onOverlayClick,
    className: createOverlayStyle({
      isAnimating: isOpening || isClosing
    }),
    "aria-controls": "modal",
    "aria-label": closeButtonAccessibleLabel,
    "aria-expanded": "true"
  }, React.createElement("div", {
    className: modalWrapperStyle,
    id: "modal"
  }, React.createElement("div", {
    className: createModalStyle({
      className: className
    }),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, React.createElement("header", {
    className: headerStyle
  }, React.createElement(Typography, {
    className: "title",
    tabIndex: "0",
    type: "h3"
  }, title), React.createElement("button", {
    className: closeStyle,
    onClick: close,
    "aria-controls": "modal",
    "aria-label": closeButtonAccessibleLabel,
    "aria-expanded": "true"
  }, React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React.createElement("path", {
    d: "M22.4716364 0L12 10.4716364 1.52727273 0 0 1.52727273 10.4716364 12 0 22.4727273 1.52727273 24 12 13.5272727 22.4716364 24l1.5272727-1.5272727L13.5272727 12 23.9989091 1.52727273z",
    fillRule: "evenodd"
  })))), React.createElement("div", {
    className: createContentStyle({
      contentCss: contentCss
    })
  }, children({
    close: close
  })))));
  if (typeof window === undefined) return null;
  return ReactDOM.createPortal(modal, getRootElement());
};

export default Modal;